import { render } from "./RecordingPanel.vue?vue&type=template&id=efc03242&scoped=true"
import script from "./RecordingPanel.vue?vue&type=script&lang=js"
export * from "./RecordingPanel.vue?vue&type=script&lang=js"

import "./RecordingPanel.vue?vue&type=style&index=0&id=efc03242&scoped=true&lang=scss"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc03242"]])

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QBtn,QIcon});
